import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mp_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken()) {
      clearToken();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/dashboard/login")) {
        window.location.href = "/dashboard/login";
      }
    }
    return Promise.reject(err);
  }
);

// public bike + content
export const fetchBikes = async (params = {}) => (await api.get("/bikes", { params })).data;
export const fetchFeaturedBikes = async () => (await api.get("/bikes/featured")).data;
export const fetchBike = async (id) => (await api.get(`/bikes/${id}`)).data;
export const fetchSiteContent = async () => (await api.get("/site-content")).data;

// public form submissions
export const submitServiceBooking = async (payload) => (await api.post("/service-bookings", payload)).data;
export const submitTestRide = async (payload) => (await api.post("/test-rides", payload)).data;

// auth
export const login = async (email, password) => (await api.post("/auth/login", { email, password })).data;
export const fetchMe = async () => (await api.get("/auth/me")).data;

// admin
export const adminCreateBike = async (payload) => (await api.post("/admin/bikes", payload)).data;
export const adminUpdateBike = async (id, payload) => (await api.put(`/admin/bikes/${id}`, payload)).data;
export const adminDeleteBike = async (id) => (await api.delete(`/admin/bikes/${id}`)).data;
export const adminUpdateSiteContent = async (data) => (await api.put("/admin/site-content", { data })).data;
export const adminListBookings = async () => (await api.get("/admin/bookings")).data;

export const adminUploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const t = getToken();
  const { data } = await axios.post(`${API}/admin/upload`, fd, {
    headers: {
      Authorization: t ? `Bearer ${t}` : "",
      "Content-Type": "multipart/form-data",
    },
  });
  return data; // { url, filename }
};

export const resolveAssetUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/uploads/")) return `${BACKEND_URL}${url}`;
  return url; // /videos/hero.mp4 etc served by frontend public
};
